export var PRESENTATION_MODE;
(function (PRESENTATION_MODE) {
    PRESENTATION_MODE["SHARE_CONTENT"] = "SHARE_CONTENT";
    PRESENTATION_MODE["SHARE_SCREEN"] = "SHARE_SCREEN";
    PRESENTATION_MODE["NONE"] = "NONE";
})(PRESENTATION_MODE || (PRESENTATION_MODE = {}));
export var PRESENTATION_CONTEXT;
(function (PRESENTATION_CONTEXT) {
    PRESENTATION_CONTEXT["VIRTUAL_HOST"] = "VIRTUAL_HOST";
    PRESENTATION_CONTEXT["PUBLISHER"] = "PUBLISHER";
    PRESENTATION_CONTEXT["APP"] = "APP";
    PRESENTATION_CONTEXT["VIRTUAL_ATTENDEE"] = "VIRTUAL_ATTENDEE";
})(PRESENTATION_CONTEXT || (PRESENTATION_CONTEXT = {}));
//# sourceMappingURL=types.js.map